import React from 'react';

// Tamaños del icono (neural-network InsideBrand)
const sizes = {
  sm: { icon: 24, text: 'text-sm',  gap: 'gap-2' },
  md: { icon: 32, text: 'text-base', gap: 'gap-2.5' },
  lg: { icon: 44, text: 'text-xl',  gap: 'gap-3' },
  xl: { icon: 60, text: 'text-3xl', gap: 'gap-3.5' },
};

/**
 * Logo Inside CRM — icono neural network InsideBrand + wordmark.
 * @param inverted  true para paneles oscuros (texto blanco)
 * @param onlyIcon  sin texto (solo la red)
 */
export const Logo = ({
  size = 'md',
  inverted = false,
  onlyIcon = false,
  className = '',
}) => {
  const s = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center ${s.gap} ${className}`} data-testid="logo">
      <img
        src="/assets/neural-network.png"
        alt="Inside CRM"
        style={{ height: s.icon, width: 'auto' }}
        className="flex-shrink-0 select-none"
        draggable={false}
      />
      {!onlyIcon && (
        <span className={`${s.text} font-heading tracking-tight leading-none`}>
          <span className={inverted ? 'font-bold text-white' : 'font-bold text-ink-900'}>
            Inside
          </span>
          <span className={inverted ? 'font-medium text-ink-300 ml-1' : 'font-medium text-ink-500 ml-1'}>
            CRM
          </span>
        </span>
      )}
    </div>
  );
};

export default Logo;
